var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59.445,
    height: 59.445,
    viewBox: "0 0 59.445 59.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 59.445,
    height: 59.445,
    transform: "translate(0 0)",
    fill: "#0d0b0e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2681",
    "data-name": "Groupe 2681",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2681-2",
    "data-name": "Groupe 2681",
    transform: "translate(0 -0.003)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_915",
    "data-name": "Trac\\xE9 915",
    d: "M947.692,10.049a1.18,1.18,0,0,1-1.18-1.18V1.178a1.18,1.18,0,0,1,2.36,0V8.87a1.18,1.18,0,0,1-1.18,1.18",
    transform: "translate(-917.969 0.002)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_916",
    "data-name": "Trac\\xE9 916",
    d: "M947.692,1661.322a1.18,1.18,0,0,1-1.18-1.18v-7.278a1.18,1.18,0,1,1,2.36,0v7.278a1.18,1.18,0,0,1-1.18,1.18",
    transform: "translate(-917.969 -1601.878)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_917",
    "data-name": "Trac\\xE9 917",
    d: "M1637.952,947.69a1.18,1.18,0,0,1,1.18-1.18h7.692a1.18,1.18,0,1,1,0,2.36h-7.692a1.18,1.18,0,0,1-1.18-1.18",
    transform: "translate(-1588.559 -917.967)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_918",
    "data-name": "Trac\\xE9 918",
    d: "M0,947.69a1.18,1.18,0,0,1,1.18-1.18H8.457a1.18,1.18,0,0,1,0,2.36H1.18A1.18,1.18,0,0,1,0,947.69",
    transform: "translate(0 -917.967)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_919",
    "data-name": "Trac\\xE9 919",
    d: "M1435.779,284.678a1.18,1.18,0,0,1,0-1.668l5.439-5.439a1.18,1.18,0,0,1,1.669,1.668l-5.439,5.439a1.18,1.18,0,0,1-1.668,0",
    transform: "translate(-1392.148 -268.865)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_920",
    "data-name": "Trac\\xE9 920",
    d: "M277.572,1452.3a1.18,1.18,0,0,1,0-1.669l5.146-5.146a1.18,1.18,0,0,1,1.668,1.669l-5.146,5.146a1.18,1.18,0,0,1-1.668,0",
    transform: "translate(-268.867 -1401.565)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_921",
    "data-name": "Trac\\xE9 921",
    d: "M1435.779,1435.777a1.18,1.18,0,0,1,1.668,0l5.439,5.439a1.18,1.18,0,0,1-1.669,1.669l-5.439-5.439a1.18,1.18,0,0,1,0-1.668",
    transform: "translate(-1392.148 -1392.146)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_922",
    "data-name": "Trac\\xE9 922",
    d: "M277.572,277.57a1.18,1.18,0,0,1,1.668,0l5.146,5.146a1.18,1.18,0,1,1-1.668,1.669l-5.146-5.146a1.18,1.18,0,0,1,0-1.668",
    transform: "translate(-268.867 -268.865)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_923",
    "data-name": "Trac\\xE9 923",
    d: "M406.408,424.416A17.957,17.957,0,1,1,413.419,423a17.9,17.9,0,0,1-7.011,1.416m0-33.909a15.9,15.9,0,1,0,15.9,15.9,15.917,15.917,0,0,0-15.9-15.9",
    transform: "translate(-376.686 -376.684)",
    fill: "#0d0b0e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoment);
export default __webpack_public_path__ + "static/media/moment.5c7181183e2558645f28c358accada50.svg";
export { ForwardRef as ReactComponent };